import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  minutes: 10,
  seconds: 0,
  quarterLog: null,
};

const logSlice = createSlice({
  name: 'log',
  initialState,
  reducers: {
    setQuarterLog: (state, action) => {

      state.quarterLog = action.payload;
    },
    setMinutesLog: (state, action) => {
      const minutes = parseInt(action.payload);
      if (Number.isInteger(minutes) && minutes >= 0) {
        state.minutes = minutes;
      }
    },
    setSecondsLog: (state, action) => {
      const seconds = parseInt(action.payload);
      if (Number.isInteger(seconds) && seconds >= 0) {
        state.seconds = seconds;
      }
    },
    setIsRunningLog: (state, action) => {
      state.isRunning = action.payload;
    },
    resetTimerLog: (state) => {
      state.minutes = 0;
    },
    selectedQuarterLog: (state, action) => {
      state.quarterLog = action.payload;
    },
  },
});

// Export actions generated by the slice
export const {
  setQuarterLog,
  setMinutesLog,
  setSecondsLog,
  setIsRunningLog,
  resetTimerLog,
  selectedQuarterLog
} = logSlice.actions;

// Export the reducer to be used in the store
export default logSlice.reducer;
